import { useEffect, useState } from "react";
import { Form, FormInput, FormActions } from "@src/components/Controls/Form";
import API from "@src/API.js";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

export default function RegisterCode() {
  const [registerData, updateRegisterData] = useState({ phoneCode: "" });
  const [smsSent, setSmsSent] = useState(false);

  useEffect(() => {
    try {
      const pending = JSON.parse(window.sessionStorage.getItem("PendingRegistrationCodes") || "null");
      if (pending) {
        setSmsSent(pending.smsSent === true);
      }
    } catch {
      /* ignore */
    }
  }, []);

  async function onDoneAsync(e) {
    e?.preventDefault?.();
    const resp = await API.postAsync("/PostRegistrationCode", { phoneCode: registerData.phoneCode });
    if (resp && resp.ok) {
      toast.success("Phone verified. Use the email link to activate your account.");
      return resp;
    }
    toast.error(resp?.jsonData?.message || "Codes did not match");
    return resp;
  }

  return (
    <div className="loginPage">
      <Form
        className="centered login loginForm"
        label="Check your email"
        object={registerData}
        onUpdate={updateRegisterData}
      >
        <p className="centered" style={{ marginBottom: "0.75rem", fontSize: "0.9rem" }}>
          We emailed you a verification link. Open it to activate your account, then sign in.
        </p>
        {smsSent ? (
          <>
            <p className="centered" style={{ marginBottom: "0.75rem", fontSize: "0.9rem" }}>
              You can also enter the SMS code below to verify your phone number. This does not
              replace email verification.
            </p>
            <FormInput field="phoneCode" label="Code Received via SMS Message" required />
            <FormActions
              doneLabel="Verify phone"
              onSaveAsync={async (e) => {
                await onDoneAsync(e);
              }}
            />
          </>
        ) : null}
      </Form>
      <p className="centered">
        <Link to="/register">Back to register</Link> · <Link to="/">Login</Link>
      </p>
    </div>
  );
}
